import React from 'react';
import PropTypes from 'prop-types';
import { analyticsHelpers, Button, toast, FormatCurrency } from 'day8-ui';
import { FaCircleInfo } from "@react-icons/all-files/fa6/FaCircleInfo";
import { getSelectedParams } from '../../../helpers/week';
import history from '../../../history';
import { updateSearch } from '../../../helpers/querystring';

const { GA4_TRIGGERS } = analyticsHelpers;
const ExtrasPricingRow = ({
  label, price, currency, id, readMoreLink
}) => {
  const { extras } = getSelectedParams(history.location);
  const isSelected = extras.includes(id);
  const handleExtras = item => {
    const { extras } = getSelectedParams(history.location);
    const newExtrasArray = [...extras];
    const index = newExtrasArray.indexOf(item);
    if (index === -1) {
    // Item is not in the array, so push it
      newExtrasArray.push(item);
      toast.success(`Added ${label}`);
    } else {
    // Item is already in the array, so remove it
      newExtrasArray.splice(index, 1);
      toast.success(`Removed ${label}`);
    }
    history.replace({
      pathname: history.location.pathname,
      search: updateSearch(history.location, {
        extras: newExtrasArray
      })
    });
  };
  return (
    <div className="dui-flex dui-justify-between dui-my-4 dui-gap-4">
      {!!readMoreLink && (
        <a href={readMoreLink} target='_blank' rel="noopener noreferrer">
          <Button
            buttonType='LINK_UNDERLINE'
            buttonSize="MEDIUM"
            rightIcon={<FaCircleInfo />}
          >
            {label}
          </Button>
        </a>
      )}
      {!readMoreLink && <p className="dui-font-normal">{label}</p>}
      <div>
        {!isSelected && (
          <Button className={GA4_TRIGGERS.ADD_FUNNEL_EXTRA_CLASS} buttonType="LINK" buttonSize="MEDIUM" onClick={() => handleExtras(id)}>
            Add
          </Button>
        )}
        {isSelected && (
          <Button className={GA4_TRIGGERS.REMOVE_FUNNEL_EXTRA_CLASS} buttonType="LINK" buttonSize="MEDIUM" onClick={() => handleExtras(id)}>
            <div className='dui-flex dui-items-center dui-gap-4'>
              <span className="">Remove</span>
              <span className=""><FormatCurrency amount={price} baseCurrency={currency} /></span>
            </div>
          </Button>
        )}
      </div>
    </div>
  );
};
ExtrasPricingRow.propTypes = {
  label: PropTypes.string,
  price: PropTypes.number,
  readMoreLink: PropTypes.string,
  id: PropTypes.nmber,
  currency: PropTypes.string
};

export default ExtrasPricingRow;
